import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '../shared/CircularProgress.component';
import { jobsSelector, unreadJobNotificationsSelector } from '../shared/jim/store/selectors';
import { Job } from './jobsMenu/types';
import { inProgressStatuses } from '../shared/jim/constants';
import { getJobProgress } from '../shared/jim/helpers';


export const JobsMenuIcon: FC<{}> = () => {
  const jobs = useSelector(jobsSelector) as Job[];
  const unreadJobsNotifications = useSelector(unreadJobNotificationsSelector) as Job[];

  const jobsInProgress = useMemo(
    () => jobs.filter(({ status }) => inProgressStatuses.includes(status)), [jobs]
  );

  const totalPercentage = useMemo(() =>
    jobsInProgress.reduce((total, job) => total + getJobProgress(job), 0) / jobsInProgress.length,
  [jobsInProgress]
  );

  return (
    <div className="jobs-menu-icon-wrapper  position-relative">
      {
        !!unreadJobsNotifications.length && (
          <div className="unread-job-notifications-badge">
            { unreadJobsNotifications.length }
          </div>
        )
      }
      {
        jobsInProgress.length
          ? (
            <CircularProgress progress={totalPercentage}>
              <span className="appkiticon icon-notification-outline"/>
            </CircularProgress>
          )
          : (
            <span className="appkiticon icon-notification-outline"/>
          )
      }
    </div>
  );
};
